/**
 * 10.9BP — PEÇAS COMUNS das estruturas do HUB (Santuário). Antes o PvpPortal e o ZonePortal
 * tinham o MESMO mesh copiado; agora a parte comum (plataforma + runa de chão + rótulo) vive aqui
 * e cada portal só constrói o que o torna diferente (arco com espadas × vórtice com coroa).
 */
import * as THREE from "three";
import { makeLabel } from "./StructureLabel";
import { energyMat, platformMat } from "./Materials";

export interface PortalBase {
  /** runa aditiva no chão — o portal gira isso no update */
  ring: THREE.Mesh;
  ringMat: THREE.MeshBasicMaterial;
}

const hex = (c: number): string => "#" + c.toString(16).padStart(6, "0");

/** Plataforma circular escura + anel de runa aditivo na cor do portal. Adiciona em `group`.
 * 10.9BQ — materiais da biblioteca (COMPARTILHADOS: o anel só gira, não é animado por material). */
export function makePortalBase(group: THREE.Group, color: number, baseEmissive = 0.18): PortalBase {
  const base = new THREE.Mesh(new THREE.CylinderGeometry(1.5, 1.7, 0.22, 28), platformMat(color, baseEmissive));
  base.position.y = 0.11;
  base.receiveShadow = true;
  group.add(base);
  const ringMat = energyMat(color, "ring");
  const ring = new THREE.Mesh(new THREE.RingGeometry(1.55, 1.9, 32), ringMat);
  ring.rotation.x = -Math.PI / 2;
  ring.position.y = 0.06;
  group.add(ring);
  return { ring, ringMat };
}

/** Rótulo flutuante na cor do portal (atalho: cor numérica → "#rrggbb"). */
export function addPortalLabel(group: THREE.Group, text: string, color: number, height = 4.4, sub?: string): void {
  group.add(makeLabel(text, hex(color), height, sub));
}
